<template>
  <popup-modal ref="popup">
    <p class="text-h6">{{ title }}</p>
    <p>
      {{ message }}<br /><span class="subtitle-1">{{ item }}</span>
    </p>
    <div v-if="showEmail">
      <v-text-field
        v-model="email"
        name="email"
        label="Проверьте e-mail или укажите его:"
        type="email"
        clearable
        @change="updateEmail"
        :rules="[rules.required]"
      ></v-text-field>
    </div>
    <v-container>
      <v-row align="center" justify="space-around">
        <v-btn small color="white" @click="_cancel">{{ cancelButton }}</v-btn>
        <v-btn
          small
          :disabled="(email == null || !emailIsValid(email)) && showEmail"
          @click="_confirm"
        >
          {{ okButton }}
        </v-btn>
      </v-row>
    </v-container>
  </popup-modal>
</template>

<script>
import PopupModal from "./PopupModal.vue";

export default {
  name: "ConfirmDialogue",
  components: { PopupModal },
  data: () => ({
    title: undefined,
    message: undefined,
    item: "",
    okButton: undefined,
    cancelButton: "Отмена",
    resolvePromise: undefined,
    rejectPromise: undefined,
    showEmail: false,
    email: null,
    rules: {
      required: (value) => !!value || "Обязательно для заполнения",
    },
  }),
  methods: {
    emailIsValid(email) {
      let pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (pattern.test(email)) {
        return true;
      }
      return false;
    },
    updateEmail() {
      this.$store.commit("updateContractorEmail", this.email);
    },
    show(opts = {}) {
      this.title = opts.title;
      this.message = opts.message;
      this.item = opts.item;
      this.okButton = opts.okButton;
      this.showEmail = opts.showEmail;
      this.inputMessage = opts.inputMessage;
      this.email = opts.email;
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton;
      }
      this.$refs.popup.open();
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    _confirm() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },
    _cancel() {
      this.$refs.popup.close();
      this.resolvePromise(false);
    },
  },
};
</script>

<style scoped>
.v-btn {
  margin: 5px;
}
</style>
